import React from 'react';
import PropTypes from 'prop-types';

const Forward5SecPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M23 .811A.75.75 0 0 1 24.281.28l3.512 3.513a1 1 0 0 1 0 1.414l-3.512 3.512A.75.75 0 0 1 23 8.189V6h-7C10.477 6 6 10.477 6 16s4.477 10 10 10a9.973 9.973 0 0 0 7.553-3.447 1.017 1.017 0 0 1 1.433-.007l.708.708a1 1 0 0 1 0 1.413C23.282 27.34 19.835 29 16 29 8.82 29 3 23.18 3 16S8.82 3 16 3h7V.811zM12.66 10h6.8v2h-4.95l-.175 2.35a4.012 4.012 0 0 1 1.645-.349C18.2 14.001 20 15.792 20 18c0 2.21-1.8 4.001-4.02 4.001A4.015 4.015 0 0 1 12 18.57h2.041a2.001 2.001 0 1 0 .439-1.916h-2.318L12.66 10z"
    />
  );
};

Forward5SecPath.propTypes = {
  fill: PropTypes.string,
};

export default Forward5SecPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/forward-5-sec.jsx